import { useRole } from 'hooks/common/useRole';
import { InfoIcon_24 } from 'assets/icons';
import { BaseAlert, AlertTypes } from 'components/Alerts';
import Tooltip from 'components/Tooltip';
import messages from './AlertLockUser.messages';
import styles from './AlertLockUser.module.css';

type Props = {
  hoursToAutoUnlock?: number;
  lockReason?: string;
  isLocked?: boolean;
};

const AlertLockUser = ({
  hoursToAutoUnlock,
  isLocked,
  lockReason,
}: Props): JSX.Element | null => {
  const { isAdmin } = useRole();
  const autolockedMessage: string | null =
    hoursToAutoUnlock && !isLocked
      ? messages.userAutoLockedStart + hoursToAutoUnlock + messages.userAutoLockedEnd
      : null;

  function displayManuallyLockedMessage() {
    if (!isLocked) return null;
    if (isAdmin) return messages.userLockedManually;
    return messages.userLocked;
  }

  const manuallyLockedMessage: string | null = displayManuallyLockedMessage();

  if (!(isLocked || hoursToAutoUnlock)) return null;

  return (
    <BaseAlert className={styles.alertLockUser} type={AlertTypes.warning}>
      {manuallyLockedMessage}
      {autolockedMessage}
      {!!lockReason && (
        <>
          <InfoIcon_24 className={styles.alertLockUser__alertIcon} />
          <Tooltip className={styles.alertLockUser__tooltip}>
            {messages.reason}
            {lockReason}
          </Tooltip>
        </>
      )}
    </BaseAlert>
  );
};

export default AlertLockUser;
